import axios from 'axios';
import store from 'store';

const state = {
  roles: {},
  paginatedRoles: {},
  paginatedRolesMeta: {},
};

const getters = {};

const mutations = {
  setRoles: (st, payload) => {
    st.roles = payload;
  },
  setPaginatedRoles: (st, payload) => {
    st.paginatedRoles = payload;
  },
  setPaginatedRolesMeta: (st, payload) => {
    st.paginatedRolesMeta = payload;
  },
};

const actions = {
  getRoles: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('setRoles', null);
      if (store.get('permissions').indexOf('carriers.roles.index') >= 0) {
        axios
          .get(`roles`)
          .then(res => {
            commit('setRoles', res.data.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      }
      resolve();
    });
  },
  getPaginatedRoles: ({ commit }, page) => {
    axios.get(`roles/list?page=${page}`).then(res => {
      commit('setPaginatedRoles', res.data.data);
      commit('setPaginatedRolesMeta', res.data.meta);
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/roles.js